export default __webpack_public_path__ + "static/media/cookie_policy.a2128bad.md";